module.exports = __webpack_public_path__ + "static/media/0011.f68a2f3b.jpg";